import { Typography } from "@mui/joy";
import { COLOR_PRIMARY } from "../../../utils/styles";

function PlaceCount(props) {
  return (
    <Typography
      level="body-sm"
      sx={{
        "&::selection": {
          backgroundColor: COLOR_PRIMARY,
        },
      }}
    >
      {props.placeData.length} results
    </Typography>
  );
}

export default PlaceCount;
